export const LogEvents = {
    VERSION_CREATION_FAILED: 'version_creation_failed',
    UPGRADE_STUDY_UPGRADE_VERSION_CREATION_FAILED: (upgradeTime) => `upgrade_study_${upgradeTime}_upgrade_version_creation_failed`,
    UPGRADE_STUDY_UPGRADE_VERSION_CREATED: (upgradeTime) => `upgrade_study_${upgradeTime}_upgrade_version_created`,
};
